import React from 'react';
import { useLocale } from '../contexts/LocaleContext';
import { cn } from '../lib/utils';
import { Button } from './ui/button';
import { ButtonTooltip } from './ui/tooltip';
import { RotatingDeleteIcon } from './RotatingDeleteIcon';

interface DataTableSelectionActionsProps {
  selectedCount: number;
  countLabel: string;
  onClear: () => void;
  onDelete?: () => void;
  deleting?: boolean;
  disabled?: boolean;
  className?: string;
}

export const DataTableSelectionActions: React.FC<DataTableSelectionActionsProps> = ({
  selectedCount,
  countLabel,
  onClear,
  onDelete,
  deleting = false,
  disabled = false,
  className,
}) => {
  const { t } = useLocale();
  const actionsDisabled = disabled || deleting;

  if (selectedCount <= 0) {
    return null;
  }

  return (
    <div className={cn('flex items-center gap-2 text-sm', className)}>
      <span className="font-medium">{countLabel}</span>
      <button
        type="button"
        className="text-xs font-medium text-scribane-green hover:underline disabled:pointer-events-none disabled:opacity-60"
        onClick={onClear}
        disabled={actionsDisabled}
      >
        {t('clear_selection')}
      </button>
      {onDelete ? (
        <ButtonTooltip tooltip={t('delete_selected_tooltip')} side="bottom">
          <Button
            type="button"
            variant="destructive"
            size="sm"
            disabled={actionsDisabled}
            onClick={onDelete}
            className="group inline-flex items-center gap-1.5"
          >
            <RotatingDeleteIcon />
            {t('delete')}
          </Button>
        </ButtonTooltip>
      ) : null}
    </div>
  );
};
